import React, { useEffect, useState } from 'react';
import LessonSidebar from './LessonSidebar';
import LessonContent from './LessonContent';
import { t } from 'i18next';
import { usePlatformAbilities } from 'src/app/hooks/usePlatformAbilities';
import { useLocation } from 'react-router-dom';

export default function CreateLesson(props) {
  const { step, contentId, lessonId, courseId } = props;
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const initialModuleId = location?.state?.moduleId;
  const editLesson = location?.state?.editLesson;
  const { abilities } = usePlatformAbilities();
  const [isEditing, setIsEditing] = useState(false);
  const [moduleId, setModuleId] = useState(initialModuleId);
  const [isSlide, setIsSlide] = useState(false);

  useEffect(() => {
    if (editLesson === true) {
      setIsEditing(true);
    }
  }, [editLesson]);

  const steps = [
    {
      id: 0,
      route: 'nome',
      text: t('lessons.stepsLessonName')
    },
    {
      id: 1,
      route: 'videoaula',
      text: t('lessons.stepsLessonVideo')
    }
  ];

  if (abilities?.quiz && !isSlide) {
    steps.push({
      id: 2,
      route: 'perguntas',
      text: t('lessons.stepsLessonQuestions')
    });
  }

  return (
    <div className="main-screen">
      <LessonSidebar
        disciplineId={contentId}
        moduleId={moduleId}
        courseId={courseId}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        steps={steps}
        edit={isEditing}
        lessonId={lessonId}
        isSlide={isSlide}
      />

      <div className="main-content">
        <LessonContent
          abilities={abilities}
          courseId={courseId}
          step={step}
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          learningSystemContentId={contentId}
          lessonId={lessonId}
          moduleId={moduleId}
          disciplineId={contentId}
          editLesson={isEditing}
          setIsSlide={setIsSlide}
          isSlide={isSlide}
        />
      </div>
    </div>
  );
}
